const clientIdDev = "85ba5e49-88b8-45a9-9c06-c77257d6a741";
const clientIdProd = "85ba5e49-88b8-45a9-9c06-c77257d6a741";

// Obtener el origen base de la aplicación
const appOrigin = window.location.origin;
const path = window.location.href;

// URLs conocidas para cada ambiente
const DEV_URL = "https://orange-cliff-0c491e40f.4.azurestaticapps.net/login";
const PROD_URL = "https://mango-island-0285d4a0f.4.azurestaticapps.net/login";
const LOCAL_URL = "http://localhost:3000/login";

const isDev = path === LOCAL_URL || path === DEV_URL;
const isProd = path === PROD_URL;

export const msalConfig = {
  auth: {
    clientId: isDev ? clientIdDev : clientIdProd,
    authority: "https://login.microsoftonline.com/5368fc5a-2692-4a6a-b226-e2802e94e22b",
    redirectUri: isDev || isProd ? path : undefined,
  },
  acceptMappedClaims: true,
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};